import cookies from "cookiesjs"

export default {
    methods: {
        getFileStreamUrl(file) {
            return __API_URL__ + '/customer_document_files/' + file.id + '/stream?token=' + cookies("token")
        },
        getFileDownloadUrl(file) {
            return __API_URL__ + '/customer_document_files/' + file.id + '/download?token=' + cookies("token")
        }
    }
}


// WEBPACK FOOTER //
// ./client/mixins/customerDocumentFiles.js